exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.table /deep/ div.toggle-master label.switch {\n  float: none !important;\n}\ntable.table td {\n  padding: 0.75rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/all-users/all-users.component.less
// module id = ../../../../../src/app/dashboard/all-users/all-users.component.less
// module chunks = 2